import { RootState } from '../store'

export const SnackbarSelectors = {
  getSnackbarQueue: (state: RootState) => state.snackbar.snackbarQueue,
}